import type { Objective } from './types';

export const OBJECTIVES_DATA: Objective[] = [
  {
    id: 'awareness',
    icon: 'volume-high',
    titleKey: 'benchmarks.objectives.awareness',
    descriptionKey: 'benchmarks.objectives.awarenessCaption',
  },
  {
    id: 'engagement',
    icon: 'heart',
    titleKey: 'benchmarks.objectives.engagement',
    descriptionKey: 'benchmarks.objectives.engagementCaption',
  },
  {
    id: 'response',
    icon: 'cloud-music',
    titleKey: 'benchmarks.objectives.response',
    descriptionKey: 'benchmarks.objectives.responseCaption',
  },
];
